<template>
    <el-dialog :title="(isEdit ? '编辑' : '添加') + '配件入库信息'" :visible.sync="visible" append-to-body v-dialogDrag width="900px"
        :close-on-click-modal="false">
        <el-form :model="form" status-icon :rules="rules" ref="form" label-position="right" label-width="100px">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="选择仓库" prop="WarehouseId">
                        <RemoteSelect v-model="form.WarehouseId" url="AccessoryEntryRecords/GetWareHouseList"
                            code="WarehouseId" name="WarehouseName" placeholder="选择仓库" :disabled="this.isEdit">
                        </RemoteSelect>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="入场编号" prop="Source">
                        <RemoteSelect v-model="form.Source" url="AccessoryEntryRecords/GetRegistrationNum"
                            code="RegistrationNum" name="RegistrationNum" placeholder="入场编号" :multiple="true">
                        </RemoteSelect>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="配件名称" prop="AccessoryName">
                        <el-input v-model="form.AccessoryName" placeholder="配件名称" :disabled="this.isEdit"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="规格型号" prop="Specification">
                        <el-input v-model="form.Specification" placeholder="规格型号" :disabled="this.isEdit"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="数量" prop="Quantity">
                        <el-input-number v-model="form.Quantity" @change="handleChange" :min="1"  placeholder="数量"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="单位" prop="Unit" :disabled="this.isEdit">
                        <el-input v-model="form.Unit" placeholder="单位"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="重量" prop="Weight">
                        <el-input v-model="form.Weight" placeholder="重量（kg）" :disabled="this.isEdit"></el-input>
                    </el-form-item>
                </el-col>
                </el-row>
            </el-form>
            <span slot="footer">
                <el-button type="primary" @click="save" :loading="loading">保 存</el-button>
                <el-button type="canale" @click="visible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </template>
    
<script>
import UploadPhoto from "@/components/UploadPhoto.vue";
export default {
    props: ["item"],
    components: {
        UploadPhoto,
    },
    data() {
        return {
            visible: false,
            loading: false,
            isable: true,
            isEdit: false,
            form: {},
            rules: {
                WarehouseId: [
                    {
                        required: true,
                        message: "不可为空",
                    },
                ],
                Source: [
                    {
                        required: true,
                        message: "不可为空",
                    },
                ],
                AccessoryName: [
                    {
                        required: true,
                        message: "不可为空",
                    },
                ],
                Specification: [
                    {
                        required: true,
                        message: "不可为空",
                    },
                ],
                Quantity: [
                    {
                        required: true,
                        message: "不可为空",
                        ...this.$g.validNumber,
                    },
                ],
                Unit: [
                    {
                        required: true,
                        message: "不可为空",
                    },
                ],
                Weight: [
                    {
                        required: true,
                        message: "不可为空",
                        ...this.$g.validNumber,
                    },
                ],
            },
        };
    },
    computed: {
    },
    watch: {
        item: {
            handler: function (v) {
                if (v.EntryId) {
                    this.isEdit = true;
                    this.$get("AccessoryEntryRecords/GetModel", {
                        EntryId: v.EntryId,
                    }).then((r) => {
                        r.Result.Source=r.Result.Source.split(',')
                        this.init({ ...r.Result });
                    });
                } else {
                    this.init({});
                    this.isEdit = false;
                }
                this.visible = true;
            },
        },
    },
    methods: {
        init(form) {
            this.form = { ...form };
            if (this.$refs["form"]) {
                this.$refs["form"].resetFields();
            }
        },
        save() {
            this.$refs["form"].validate((valid) => {
                if (!valid) {
                    return;
                }
                let params = { ...this.form };
                params.Source=params.Source.join(',')
                this.loading = true;
                if (this.isEdit) {
                    this.$post("AccessoryEntryRecords/Edit", params)
                        .then((r) => {
                            this.$message.success("修改成功");
                            this.visible = false;
                            this.$emit("success");
                        })
                }
                else {
                    this.$post("AccessoryEntryRecords/Add", params)
                        .then((r) => {
                            this.$message.success("添加成功");
                            this.visible = false;
                            this.$emit("success");
                        })
                }
                this.loading = false;
            });
        },
        handleChange(values) {
            console.log('1111',values)
        },

    },
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";
h4 {
    margin-top: 10px;
    @include font_color("text-color2");
}
</style>